const languagePack = {
    seo: {
        home: {
            title: "ROY GYM Székesfehérvár | Modernes Fitnessstudio",
            description:
                "Modernes Fitnessstudio in Székesfehérvár: Pilates, Zirkeltraining, TRX, Bodyshaping, Stretching & Mobilität, Functional Workouts sowie Personal- und Gruppentraining."
        },
        services: {
            title: "Leistungen | ROY GYM – Kurse & Training",
            description:
                "Entdecke unsere Kurse und Trainings: Pilates, Zirkeltraining, TRX, Bodyshaping, Stretching & Mobilität, funktionelles Training und Personal Training."
        },
        pricelist: {
            title: "Preisliste | ROY GYM – Pässe & Tickets",
            description:
                "Preise für Tageskarten und Mitgliedschaften: Monat, 10er-Karte, 3/6/12 Monate sowie Studenten- und Seniorenrabatte."
        },
        about: {
            title: "Über uns | ROY GYM – Familiäres Fitnessstudio",
            description:
                "Lerne ROY GYM kennen: Team, familiäre Atmosphäre und moderne Ausstattung. Unterstützung, Motivation und Training für jedes Level."
        },
        news: {
            title: "Neuigkeiten | ROY GYM",
            description:
                "Aktuelle Neuigkeiten, Events, Aktionen und Updates aus dem ROY GYM. Bleib auf dem Laufenden, was im Studio passiert."
        },
        trainers: {
            title: "Trainer | ROY GYM – Personal Training",
            description:
                "Unsere Trainer im Überblick: Profile, Kontakte und Schwerpunkte. Unterstützung bei Abnehmen, Muskelaufbau und Lifestyle-Change."
        },
        timetable: {
            title: "Stundenplan | ROY GYM – Gruppenkurse",
            description:
                "Sieh dir den aktuellen Stundenplan der Gruppenkurse an – Zeiten, Updates und Hinweise. Plane dein Training ganz einfach."
        },
        gallery: {
            title: "Galerie | ROY GYM",
            description:
                "Fotos aus dem ROY GYM: Studio, Gerätepark und Atmosphäre. Schau dich um, bevor du uns besuchst."
        },
        career: {
            title: "Karriere | ROY GYM",
            description:
                "Offene Stellen im ROY GYM: Personaltrainer, Reinigungskräfte und mehr. Infos zur Bewerbung und Kontaktmöglichkeiten."
        },
        company: {
            title: "Impressum | ROY GYM",
            description:
                "Impressum und Anbieterangaben zur ROY GYM Website: Unternehmens- und Hostingdaten sowie Kontakt- und Rechtshinweise."
        },

        // Optional (recommended): noindex these pages
        notfound: {
            title: "404 – Seite nicht gefunden | ROY GYM",
            description:
                "Die gewünschte Seite wurde nicht gefunden. Bitte prüfe die URL oder gehe zurück zur Startseite."
        },
        error: {
            title: "Fehler aufgetreten | ROY GYM",
            description:
                "Die Seite konnte wegen eines technischen Problems nicht geladen werden. Bitte später erneut versuchen oder zur Startseite zurückkehren."
        }
    },
    notfound: {
        title: "Hoppla!",
        message: "Diese Seite existiert nicht!",
        backhome: "Zurück zur Startseite"
    },
    error: {
        title: "Ein Fehler ist aufgetreten",
        message: "Fehlermeldung: ",
        backhome: "Zurück zur Startseite"
    },
    common: {
        loading: "Laden",
        loadingOptions: [
            "Muskeln werden geladen…",
            "Scheiben werden aufgelegt…",
            "Wiederholungen werden gezählt…",
            "Proteinshake wird geschüttelt…",
            "Bank wird abgewischt…",
            "Eine Wiederholung extra fürs Glück…",
            "Magnesia auf die Stange…",
            "Letzter Satz wird ausgepresst…",
            "Wasserflasche wird nachgefüllt…",
            "Posen vor dem Spiegel…",
            "Pre-Workout wird getrunken…",
            "Regeneration läuft…",
            "Vitamine werden gesucht…",
            "Hähnchen wird gekocht…",
            "Beintag-Vorbereitung läuft…",
            "Den Bizeps pumpen…",
            "Supersatz wird gestartet…"
        ]
    },
    hero: {
        h1: "Modernes Fitnessstudio in Székesfehérvár – ROY GYM",
        p: "Pilates, Zirkeltraining, TRX, Körperformung, Stretching & Mobilität, funktionelle Workouts sowie Personal- und Gruppentrainings. Unser Studio verfügt außerdem über einen professionellen Gerätepark."
    },
    nav: {
        about: "Über uns",
        services: "Leistungen",
        servicesDropdown: {
            pilates: "Pilates",
            koredzes: "Zirkeltraining",
            cardiowalk: "Cardio-Walk",
            trx: "TRX",
            alakformalo: "Körperformungstraining",
            mobilitas: "Dehnung & Mobilität",
            funkcionalis: "Funktionelles Training",
            szemelyiedzes: "Persönliches Training"
        },
        gallery: "Galerie",
        trainers: "Trainer",
        contact: "Kontakt",
        news: "Nachricht",
        pricelist: "Preisliste",
        timetable: "Zeitplan",
        career: "Karriere"

    },
    home: {
        hero: {
            slogen: "Fühl dich zugehörig",
            newcomer: "Neu bei uns?",
            scrollcue: "Runterscrollen"
        },
        pricelist: {
            title: "Unser Angebot",
            viewFull: "Gesamte Preisliste anzeigen"
        },
        services: {
            title: "Wähle aus unseren Leistungen",
            viewFull: "Alle Leistungen"
        },
        trainers: {
            title: "Wir helfen dir, deine Ziele zu erreichen",
            viewFull: "Alle Personal Trainer"
        }
    },
    career: {
        title: "Karriere",
        subtitle: "Schließe dich dem RoyGym-Team an!",
        intro:
            "Wir sind ständig auf der Suche nach dynamischen, engagierten Mitarbeitern, die unsere Leidenschaft für Sport und einen gesunden Lebensstil teilen.",
        positionsTitle: "Aktuelle Möglichkeiten",
        positions: {
            trainer: {
                title: "Personaltrainer",
                desc:
                    "Wir erwarten erfahrene, motivierte Fachkräfte, die den Fortschritt unserer Mitglieder unterstützen; Trainer erhalten kein separates Gehalt.",
                info:
                    "Wichtig: Für Personaltrainer fallen weder Abgaben noch Mietgebühren an – Voraussetzung ist lediglich, dass der Kunde über eine gültige Tageskarte oder Mitgliedschaft verfügt.",
                exception:
                    "Ausnahme: Hält der Trainer einen Gruppenkurs, der in den offiziellen Stundenplan aufgenommen wird, ist eine separate Vereinbarung erforderlich."
            },
            cleaner: {
                title: "Reinigungskräfte",
                desc:
                    "Wir suchen gewissenhafte und zuverlässige Mitarbeiter, die zur Sauberkeit und Hygiene des Studios beitragen."
            }
        },
        applyTitle: "Bewerbung",
        applyDesc:
            "Wenn du Teil eines professionellen und freundlichen Teams werden möchtest, sende deinen Lebenslauf mit Foto an:",
        phoneDesc: "Bei Fragen ruf uns gerne an:"
    },
    news: {
        title: "Nachricht",
        loading: "Nachrichten werden geladen...",
    },
    timetable: {
        title: "Zeitplan",
        loading: "Fahrplan wird geladen..."
    },
    pricelist: {
        title: "Preisliste",
        sections: {
            adult: {
                title: "Erwachsenenpässe und -tickets",
                items: [
                    { name: "Tagesticket", price: "2 000 Ft", desc: "Gültig für einen einmaligen Eintritt, ganztägige Nutzung des Fitnessstudios." },
                    { name: "Monatspass", price: "17 000 Ft", desc: "30 Tage gültig, unbegrenzter Zugang zum Fitnessstudio." },
                    { name: "10er-Karte", price: "17 000 Ft", desc: "60 Tage gültig, insgesamt 10 Eintritte." },
                    { name: "3-Monats-Pass", price: "46 000 Ft", desc: "90 Tage gültig, unbegrenzter Zugang." },
                    { name: "6-Monats-Pass", price: "88 000 Ft", desc: "180 Tage gültig, unbegrenzter Zugang." },
                    { name: "12-Monats-Pass", price: "166 900 Ft", desc: "Jahreskarte – beste Wahl für tägliches Training." },
                ]
            },
            discount: {
                title: "Studenten- und Rentnerausweise",
                items: [
                    { name: "Tagesticket", price: "2 000 Ft", desc: "Gültig für einen einmaligen Eintritt." },
                    { name: "Monatspass", price: "14 000 Ft", desc: "30 Tage unbegrenzter Zugang zum ermäßigten Preis." },
                    { name: "10er-Karte", price: "14 000 Ft", desc: "60 Tage gültig, 10 Eintritte." },
                    { name: "3-Monats-Pass", price: "36 000 Ft", desc: "90 Tage gültig, unbegrenzter Zugang." },
                    { name: "6-Monats-Pass", price: "71 000 Ft", desc: "180 Tage gültig, beliebige Nutzung." },
                    { name: "12-Monats-Pass", price: "138 000 Ft", desc: "360 Tage gültig, Jahreskarte mit Ermäßigung." }
                ]
            },
            group: {
                title: "Gruppenkurse",
                items: [
                    { name: "Einzelkarte", price: "3 000 Ft", desc: "Einmalige Teilnahme an einem Gruppenkurs." },
                    { name: "5er-Karte", price: "13 500 Ft", desc: "30 Tage gültig, 5 Gruppenkurse." },
                    { name: "10er-Karte", price: "27 000 Ft", desc: "60 Tage gültig, 10 Gruppenkurse." }
                ],
                note: [
                    "Gruppenkarten beinhalten die Nutzung des Studios vor und nach dem Kurs.",
                    "Bitte bring deine Karte jedes Mal mit – ein Besuch wird automatisch abgezogen.",
                    "Vorherige Anmeldung erforderlich, um einen Platz zu sichern."
                ]
            },
        },
        footer: "Alle Preise sind in HUF angegeben und enthalten die Mehrwertsteuer.",
        specialDiscount: "Sonderrabatt!",
    },
    services: {
        title: "Dienstleistungen",
        pilates: {
            name: "Pilates",
            desc:
                "Pilates ist eine tiefenmuskulatur-stärkende, ruhige Trainingsmethode, die den Schwerpunkt auf die stabilisierenden Rumpfmuskeln, die Körperhaltung und die Atmung legt. Sie ist ideal, wenn du deine Bauch- und Rückenmuskeln kräftigen, deine Haltung verbessern, Rücken- oder Lendenschmerzen lindern und dich mental auftanken möchtest. Für Anfänger wie Fortgeschrittene geeignet – schonend, aber äußerst effektiv."
        },

        koredzes: {
            name: "Zirkeltraining",
            desc:
                "Zirkeltraining ist eine effektive und abwechslungsreiche Trainingsform, bei der du mehrere Übungen nacheinander an unterschiedlichen Stationen ausführst. Sie kombiniert Kraft- und Ausdaueraufbau, verbessert die Körperzusammensetzung, beschleunigt den Stoffwechsel und steigert die Fettverbrennung. Durch die ständige Abwechslung wird es nie langweilig und ist für jedes Fitnessniveau geeignet."
        },

        cardiowalk: {
            name: "Cardiowalk",
            desc:
                "Cardiowalk ist ein einzigartiges, dynamisches Training, das zügiges Gehen mit rhythmischer Musik verbindet. Während der Stunde arbeiten wir mit Steigungen, wechselnden Tempi und kontinuierlichen Anweisungen, um die Fettverbrennung zu steigern, die Muskulatur des Unterkörpers zu formen und die Ausdauer zu verbessern. Besonders geeignet für alle, die keine Sprung- oder Hochbelastungsbewegungen mögen, aber dennoch ein effektives, schwungvolles und gelenkschonendes Training suchen."
        },

        trx: {
            name: "TRX",
            desc:
                "TRX ist ein Schlingentrainings-Gerät, mit dem wir Übungen mit dem eigenen Körpergewicht ausführen. Es fördert herausragend die Rumpfstabilität, Kraft, Balance und Koordination. Ein großer Vorteil ist die leicht regulierbare Intensität, sodass Anfänger wie Fortgeschrittene ihre Herausforderung finden."
        },

        alakformalo: {
            name: "Bodyshaping",
            desc:
                "Beim Bodyshaping arbeiten wir gezielt an typischen Problemzonen wie Bauch, Oberschenkel, Gesäß und Armen. Durch den Wechsel von Kraft- und Fettverbrennungs-Blöcken formen wir effektiv die Silhouette und erhöhen die Straffheit. Ideal, wenn du einen strafferen Körper und ein besseres Wohlbefinden anstrebst."
        },

        mobilitas: {
            name: "Stretching & Mobilität",
            desc:
                "Stretching und Mobilität sind entscheidend für einen gesunden Bewegungsumfang und die Verletzungsprophylaxe. In diesen Stunden fördern wir nicht nur die Beweglichkeit, sondern helfen auch, Spannungen abzubauen, Muskelsteifheit zu lösen und das Körperbewusstsein zu verbessern. Empfohlen als Ergänzung zu anderen Trainingsformen."
        },

        funkcionalis: {
            name: "Funktionelles Training",
            desc:
                "Funktionelles Training basiert auf alltäglichen Bewegungsmustern – Kniebeugen, Heben, Ziehen, Drücken – und steigert die Gesamtleistung des Körpers. Wir arbeiten mit dem eigenen Körpergewicht, Hanteln, Kettlebells oder anderen Geräten. Es verbessert Kraft, Ausdauer, Koordination und Balance – ein echtes Ganzkörper-Workout."
        },

        szemelyiedzes: {
            name: "Persönliches Training",
            desc:
                "Wenn du individuelle Betreuung möchtest, unterstützen wir dich im Personal Training bei der Erreichung deiner Ziele – ob Gewichtsreduktion, Muskelaufbau, Rehabilitation oder Lifestyle-Veränderung. Die Einheiten sind vollständig auf dich zugeschnitten, und dein Trainer begleitet dich auf jedem Schritt deines Weges."
        }
    },

    about: {
        title: "Über uns",
        intro: "Betritt unser Studio – hier wachsen nicht nur Muskeln, sondern auch Gemeinschaft.",
        team: "Wir sind Roland und Daniella, zwei engagierte Sportbegeisterte, die ihre Leidenschaft für Menschen und Bewegung in diesen Treffpunkt verwandelt haben. Mit der Eröffnung entstand ein Ort, an dem sich jeder heimisch fühlen darf – ob Neuling oder Profi, jung oder erfahren.",
        familyAtmosphere: "Eine familiäre Atmosphäre ist bei uns keine Floskel: Gäste werden mit Namen begrüßt, ernsthaft betreut und unterstützt – unabhängig davon, ob sie einen neuen Lebensstil, Gewichtsreduktion, mehr Kraft oder einfach stressfreie Bewegung suchen.",
        groupClasses: "Ein abwechslungsreicher Kursplan bietet alles von Fettverbrennung über Kraftaufbau und Mobilitätsarbeit bis hin zu regenerierenden, energiegeladenen Einheiten, sodass jeder den passenden Kurs findet.",
        membership: "Vergünstigte Abonnements erleichtern regelmäßige Teilnahme, Einzelbesuche bleiben flexibel – so passt das Training stets in den persönlichen Rhythmus und zu individuellen Zielen.",
        philosophy: "Da Training Seele wie Körper formt, schaffen wir ein motivierendes, herzliches und inspirierendes Umfeld, in dem jeder ohne Vorurteile und Leistungsdruck selbstbewusst eintritt.",
        invitation: "Schau vorbei, probiere uns aus, lerne uns kennen und werde Teil einer unterstützenden Gemeinschaft, die gemeinsam deine Ziele verwirklicht."
    },
    gallery: {
        title: "Galerie",
        loading: "Galerie wird geladen..."
    },
    trainers: {
        title: "Trainer",

        /* Labels reused in every profile */
        labels: {
            phone: "Telefon",
            email: "E-Mail",
            instagram: "Instagram"
        },

        /* ----------------------------------------------------------------
           Individual trainers
        ----------------------------------------------------------------- */
        list: {
            // janika: {
            //     name: "Deme János",
            //     phone: "+36 20 373 4111",
            //     email: "demejani@icloud.com",
            //     instagram: "@deme_jani",
            //     bio: "Hallo, ich bin János Deme.\n\nIch habe vor 10 Jahren mit dem Krafttraining begonnen und es ist ein fester Bestandteil meines Lebens geworden. Davon habe ich 3 Jahre lang selbst an Wettkämpfen teilgenommen und 3 Jahre als Wettkampfvorbereitungs-Coach gearbeitet.\n\n🏆 Wabba Junior BB 🥇\n🏆 Wabba Athletic BB 🥇\n🏆 Wabba Short BB 🥇\n\n2021 schloss ich die IWI International Fitness School ab, Fachrichtungen Sportinstruktor, Bodybuilding & Fitness sowie Wettkampfvorbereitung.\n\nSeit 4 Jahren arbeite ich hauptberuflich als Trainer. Ich betreue jeden, der Sport treiben möchte – unabhängig von Alter, Ziel oder Geschlecht. Auch als Wettkampfcoach konnten wir bereits große Erfolge bis hin zu Goldmedaillen feiern – werde du der Nächste!\n\n💰 *Preise*\n• Personal Training: 5 000 Ft / Einheit\n• Partnertraining: 3 500 Ft / Person / Einheit\n\n8er-Karte: 35 000 Ft\n10er-Karte: 40 000 Ft\n12er-Karte: 45 000 Ft\nStudentenrabatt: 5 000 Ft!\n\n*Ernährungsplan*\n20 000 Ft • 15 000 Ft für Karteninhaber\n\nIch zeige dir den Weg – wer ihn geht, erreicht sein Ziel!\n\nMelde dich per Nachricht oder Telefon."
            // },

            roland: {
                name: "Fehér Roland",
                phone: "+36 30 491 9340",
                email: "apika89305@gmail.com",
                instagram: "@fit_by_roy",
                image: "roland.jpg",
                bio: "Hallo! Ich bin Roland Fehér, Inhaber des Roy Gym.\n\nUnternehmer, seit 10 Jahren Personal- und Gruppentrainer sowie Wettkämpfer. Wer mich kennt, weiß, dass das Trainersein für mich keine Arbeit, sondern eine Berufung ist – mein Leben dreht sich geistig, körperlich und seelisch darum.\n\nMeine Erfolge verdanke ich der Tatsache, dass ich die Ziele meiner Klienten in den Vordergrund stelle und sie entsprechend meinem besten Wissen begleite. Ich möchte möglichst vielen Menschen einen gesunden Lebensstil vermitteln und ihnen in der hektischen Welt eine Auszeit bieten.\n\n────────────────────────────\n💡 *Was kann ich bieten?*\n\n• **Lifestyle- und Ernährungsberatung** – individuelle, an deinen Tagesablauf angepasste Ernährungsformen, Rezepte und Tipps für nachhaltigen Fortschritt.\n\n• **Personal Training** (5 000 Ft / Einheit) – 1:1, 60 Minuten volle Aufmerksamkeit, abgestimmt auf dich und deine Ziele nach einer Bestandsaufnahme. Pilates- und TRX-Option.\n\n• **Partnertraining** (3 500 Ft / Person / Einheit) – für Freunde, Paare, Familienmitglieder. 60 Minuten leicht nachvollziehbare, aber dynamische gemeinsame Übungen.\n\n• **Gruppentraining** (2 500 Ft / Person / Einheit) – Zirkeltraining mit mehreren Stationen: Hanteln, TRX, Widerstandsbänder, Step-Board, instabile Geräte usw. Geeignet für Anfänger und Fortgeschrittene.\n\nLass uns gemeinsam den Weg der Veränderung gehen und etwas Dauerhaftes schaffen, das dich dein Leben lang begleitet! 🙏\n\nSchreib mir eine Nachricht oder ruf an unter +36 30 491 9340.\nE-Mail: apika89305@gmail.com\nInstagram: @fit_by_roy"
            },

            daniella: {
                name: "Bakos Daniella",
                phone: "+36 30 959 2613",
                email: "mailto:daniellabakos6@gmail.com",
                instagram: "https://instagram.com/daniella_bakos",
                image: "daniella.jpg",
                bio:
                    "Hallo!\n\n" +
                    "Ich bin Bakos Daniella, Personal- und Partnertrainerin sowie Inhaberin des Roy Gym.\n" +
                    "Seit 6 Jahren ist Bodybuilding Teil meines Lebens, seit 3 Jahren starte ich in der Bikini-Fitness-Kategorie und konnte dabei starke Ergebnisse erzielen.\n" +
                    "Für mich ist das nicht nur Sport – es ist mein Lifestyle, meine Leidenschaft, die meinen Alltag durchzieht. Genau diese Leidenschaft möchte ich auch an dich weitergeben, damit du deine eigene Stärke und dein Selbstvertrauen findest und erlebst, wie sich dein Körper – und dein ganzes Leben – verändern kann.\n\n" +
                    "Ich glaube nicht an Standardschablonen. Ich betreue jede*n so, als würde ich für meine eigenen Ziele arbeiten: Ich höre dir zu, achte auf deinen Körper, deine Seele und deine Gedanken und passe das Programm komplett an dich an – damit Training kein lästiges \"Muss\"-Programm ist, sondern ein Erlebnis, das dich formt, dir Energie gibt und die Beziehung zu dir selbst verbessert.\n\n" +
                    "Was du bei mir bekommst:\n" +
                    "– Lifestyle- & Ernährungsberatung\n" +
                    "Echte, nachhaltige Lösungen – keine weitere \"Wunderdiät\".\n" +
                    "Leckere, budget- und zeitsparende Rezepte, praktische Tipps und kleine Tricks, die nicht nur zu dir, sondern auch perfekt in den Alltag deiner Familie passen.\n\n" +
                    "– Personal Training – 6.000 Ft / Einheit\n" +
                    "60 Minuten volle Aufmerksamkeit nur für dich. Ob Figurformung, Kraftaufbau oder Regeneration – jede Bewegung dient deinen Zielen.\n\n" +
                    "– Partner Training – 3.000 Ft / Person / Einheit\n" +
                    "Wenn du jemanden an deiner Seite möchtest, der an dich glaubt – auch dann, wenn du selbst zweifelst: Ich bin da!\n" +
                    "Du kannst mit Freund*in, Partner*in oder sogar mit Eltern/Kind trainieren, und ich garantiere: Jede Einheit ist motivierend, erlebnisreich und in bester Stimmung.\n\n" +
                    "Am Anfang nehmen wir dir nur eine Stunde am Tag – aber diese eine Stunde kann dein ganzes Leben verändern. Mit der Zeit wirst du einfach stärker, selbstbewusster und energiegeladener. Wenn du für eine Stunde aus dem Alltag aussteigen, dich auf dich selbst konzentrieren, dich verändern und den Prozess sogar genießen möchtest, melde dich gerne – und lass uns gemeinsam starten!\n\n" +
                    "8000 Székesfehérvár, Budai út 154.\n" +
                    "Roy GYM Trainingsstudio",
            },

            eszter: {
                name: "Pataki Eszter",
                phone: "+36 70 380 9749",
                email: "f.patakieszter@gmail.com",
                instagram: "",
                image: "eszter.jpg",
                bio: "Ich bin Eszter Ferkócza Pataki. \n\nIch habe an der Naturwissenschaftlichen Fakultät der Universität Pécs im Studiengang Personalwesen abgeschlossen. \n\nMein ganzes Leben ist von der Liebe zum Sport geprägt. Als Kind habe ich Ballett getanzt und viele Jahre lang geritten. Figurformende und Gruppenfitnesskurse wurden ein Teil meines Lebens, weshalb ich eine Ausbildung zur Fitnesstrainerin absolviert habe. Vor drei Jahren entdeckte ich TRX-Training und integrierte es in meinen Alltag. Heute halte ich als ausgebildete TRX-Trainerin selbst Trainingsstunden. \n\nIch halte eine gesunde Ernährung neben dem Sport für sehr wichtig, denn Bewegung und Ernährung zusammen sind am wirksamsten. Als Ernährungsberaterin unterstütze ich gerne auch in diesem Bereich. In meinen Gruppen- wie auch Einzelstunden lege ich Wert auf Abwechslung, Freude und die mögliche Vorbeugung von Verletzungen. \n\nMein Motto: Die Schönheit kommt von innen. \n\nGruppenkurs: 2.500 HUF \n\nEinzeltraining: 4.000 HUF/Stunde \n\nEinzeltraining für 2 Personen: 3.000 HUF/Person"
            },

            reka: {
                active: false,
                name: "Böröcz Réka",
                phone: "+36 30 974 9780",
                email: "mailto:torzsokreka@gmail.com",
                instagram: "https://instagram.com/rk.fitzone",
                image: "reka.jpeg",
                bio: "Réka Böröcz – Fitnesstrainerin, Postnatal-Trainerin\n\nIch bin überzeugt, dass Bewegung nicht nur den Körper, sondern auch den Geist formt. Als Postnatal-Trainerin lege ich besonderen Wert auf die Rehabilitation nach der Geburt; mein wichtigstes Ziel ist es, Müttern zu helfen, sicher, schrittweise und mit Selbstvertrauen zur Bewegung zurückzukehren.\n\nIch möchte die – vor allem bei Frauen verbreiteten – Ängste und Mythen rund um Krafttraining ausräumen und zeigen, dass Kraftaufbau nicht nur das Äußere verändert; er macht dich auch im Alltag selbstbewusster, energiegeladener und ausgeglichener.\n\nAls Frau und Mutter weiß ich, wie herausfordernd es ist, Zeit für sich selbst zu finden; deshalb stehen in meinen Einheiten Wirksamkeit, Sicherheit und eine gute Atmosphäre im Vordergrund. Ob Rückbildung nach der Geburt, Training mit dem eigenen Körpergewicht, TRX oder Krafttraining – bei mir findet jede*r sein eigenes Tempo und die Freude am Fortschritt.\n\nPersonal Training: 5.000 HUF/Einheit\nPartnertraining: 3.500 HUF/Person/Einheit",
            },

            rita: {
                active: false,
                name: "Szalai Rita",
                phone: "+36 30 293 6002",
                email: "rszalai1@gmail.com",
                instagram: "",
                image: "rita.jpg",
                bio: "Hallo, ich bin Rita Szalai – Gruppentrainerin, Functional Trainerin und Lifestyle-Coach.\n\nBewegung ist seit meiner Kindheit Teil meines Lebens: 13 Jahre lang habe ich getanzt, danach folgten Aerobic und viele weitere Sportarten. In den letzten Jahren habe ich mich in funktionelles Training und Crossfit verliebt – sie formen nicht nur den Körper, sondern beseitigten auch meine Rückenschmerzen und gleichen die sitzende Arbeit aus.\n\n**Qualifikationen**\n• Lifestyle- und Ernährungsberaterin (2020)\n• Functional Trainerin (2022)\n• Group Fitness Instructor\n\nIch bilde mich ständig weiter, besonders zu den Themen hormonelles Gleichgewicht, Nahrungsunverträglichkeiten und spezielle Ernährungsformen (vegetarisch, glutenfrei).\n\n**Wobei ich helfen kann**\n• Ernährungsberatung, Unterstützung beim Lebensstilwandel\n• Alternative Ernährung bei Nahrungsunverträglichkeiten\n• Unterstützung des vegetarischen Lebensstils (ich ernähre mich selbst so)\n• Functional- und TRX-Training\n• Verbesserung von Ausdauer und Kraft\n• Herstellung des körperlich-seelischen Gleichgewichts\n\n**Preise**\n• Personal Training – 5 000 Ft / Einheit (maximale Aufmerksamkeit)\n• Partnertraining – 3 500 Ft / Person / Einheit\n• Gruppentraining – 2 500 Ft / Person / Einheit\n\nSchreib mir eine Nachricht oder ruf an unter +36 30 293 6002.\nE-Mail: rszalai1@gmail.com"
            },

            mark: {
                name: "Kardos Márk",
                phone: "+36 20 313 8676",
                email: "mailto:markkardos.99@gmail.com",
                instagram: "https://instagram.com/kardosmark",
                image: "mark.jpg",
                bio: "Ich bin Márk Kardos, Personal Trainer und Bodybuilding-Fitness-Sportlehrer.\n\nSport ist seit meinem 12. Lebensjahr Teil meines Lebens. Den Trainerberuf habe ich gewählt, weil ich anderen helfen möchte, gesünder, stärker und selbstbewusster zu werden.\n\nJedes Training ist auf individuelle Ziele zugeschnitten. Aktuelles Fachwissen, eine motivierende Atmosphäre und eine unterstützende Haltung erwarten dich jedes Mal.\nWenn du dich weiterentwickeln und dabei Spaß haben möchtest, freue ich mich auf dich!\n\nKontakt:\nTelefon: +36 20 313 8676\nInstagram: kardosmark\nE-Mail: markkardos.99@gmail.com"
            },

            kristof: {
                active: false,
                name: "Kuncz Kristóf",
                phone: "+36 30 870 3980",
                email: "mailto:kunczkristof.trainer@gmail.com",
                instagram: "https://instagram.com/kuncz.kristof",
                image: "kristof.jpg",
                bio: "Hallo, ich bin Kristóf Kuncz.\n\nNach mehr als 10 Jahren Trainingserfahrung habe ich endlich mit dem Coaching begonnen.\n\nIch gehe das Training stets so an, dass sich investierte Zeit und Energie maximal in Ergebnissen auszahlen. In den letzten Jahren habe ich mich kontinuierlich weitergebildet, um allen, die um meine Hilfe bitten, aktuelles Wissen und Erfahrung bieten zu können.\n\nWobei kann ich dir helfen?\n\n• Personal Training\n• maßgeschneiderter Trainingsplan\n• Ernährungsberatung\n• Erstellung eines Ernährungsplans\n\nPreise für Training\n• Personal Training: 5.000 HUF/Einheit\n• Partnertraining: 3.500 HUF/Person/Einheit\n\nKartenpreise\n• 8-Einheiten-Karte: 35.000 HUF\n• 12-Einheiten-Karte: 50.000 HUF\n\nBereit für Veränderung? Es ist Zeit, deine Ziele zu erreichen!\nMelde dich noch heute, und wir starten deine Transformation!\n\nAnfragen per Telefon, in den sozialen Medien oder per E-Mail!",
            },

            istvan: {
                name: "Molnár István Márk",
                phone: "+36 20 482 4694",
                email: "mailto:molnaredzo@gmail.com",
                instagram: "https://instagram.com/mlnr_istvan",
                image: "istvan.jpg",
                bio: "Hobbybox-Trainer. Ich biete Hobbybox-Training, individuelle Trainingspläne, Ausdauer- und Kraftaufbau sowie Unterstützung bei Technik und Ernährung."
            },
            balazs: {
                name: "Csata Balázs",
                phone: "+36 70 414 8877",
                email: "mailto:csatabalazs911@gmail.com",
                instagram: "https://instagram.com/balazs.csata",
                image: "balazs.jpg",
                bio: "Personal Trainer. Ich unterstütze dich mit Einzel- und Partnertraining, individuellen Trainingsplänen, Ernährungsberatung und der Erstellung von Ernährungsplänen."
            }
        }
    },
    company: {
        title: "Impressum",
        sectionTitle: "Unternehmens- und Hostinganbieter-Informationen",
        businessTitle: "Unternehmensdaten",
        businessName: "Firmenname",
        address: "Geschäfts-/Postanschrift",
        taxNumber: "Steuernummer",
        regNumber: "Registrierungsnummer",
        phone: "Telefonnummer",
        email: "E-Mail",
        bankAccount: "Bankverbindung",
        hostingTitle: "Hostinganbieter-Daten",
        hostingName: "Firmenname",
        hostingAddress: "Adresse"
    },
    footer: {
        contactTitle: "Kontakt",
        hoursTitle: "Öffnungszeiten",
        hoursWeek: "Montag – Freitag: 6:00 – 22:00",
        hoursWeekend: "Samstag – Sonntag: 8:00 – 20:00",
        followTitle: "Folge uns",
        address: "Budai Straße 154, Székesfehérvár",
        impresszumTitle: "Impressum",
        creditPrefix: "Entworfen und erstellt von",
        creditName: "Clarity Works"
    },
}

export default languagePack
